import React, { ButtonHTMLAttributes } from 'react'

import { ButtonStyles } from './Button.styles'

export interface IProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  buttonRef?: React.Ref<HTMLButtonElement>
  variant?: 'filled' | 'plain'
}

export const Button: React.FC<IProps> = ({
  children,
  buttonRef = null,
  type = 'button',
  variant = 'filled',
  ...props
}) => (
  <ButtonStyles ref={buttonRef} type={type} variant={variant} {...props}>
    {children}
  </ButtonStyles>
)
